/**
 * CFOP (Código Fiscal de Operações e Prestações) table, indexed by the 4 digit code.
 *
 * Built from the consolidated Anexo II of Convênio SINIEF s/nº of 15 December 1970, the text in
 * force (given its current wording by Ajuste SINIEF 03/24 and last amended by Ajuste SINIEF
 * 39/25), not from the frozen 2001 text of Ajuste SINIEF 07/01.
 *
 * Group and subgroup headers (codes ending in "00" or "50", e.g. "1000", "1100", "1150")
 * are section titles from the official nomenclature rather than operable codes, so they
 * are excluded: the annex prints them in upper case with no "Classificam-se neste código"
 * body, unlike the operable codes they head (1151, 1152, ...).
 *
 * Generated by `node ./scripts/cfop.ts`. Do not edit by hand.
 *
 * @see Official: https://www.confaz.fazenda.gov.br/legislacao/ajustes/sinief/cfop_cvsn_1-6.24
 * Anexo II of Convênio SINIEF s/nº 1970, the CFOP table in force.
 * @see Official: https://www.confaz.fazenda.gov.br/legislacao/ajustes/sinief/cvsn_70
 * Convênio SINIEF s/nº 1970, the consolidated text the annex belongs to.
 * @see Official: https://www.confaz.fazenda.gov.br/legislacao/ajustes/2025/AJ039_25
 * Ajuste SINIEF 39/25, the last amendment the annex carries (CFOP 7.667, from 01.02.26).
 * @see Official: https://www.confaz.fazenda.gov.br/legislacao/ajustes/2001/AJ_007_01
 * Ajuste SINIEF 07/01, the historical text that gave the CFOP its 4 digit form.
 */
export const CFOP_TABLE: Record<string, string> = {
	"1101": "Compra para industrialização ou produção rural",
	"1102": "Compra para comercialização",
	"1111":
		"Compra para industrialização de mercadoria recebida anteriormente em consignação industrial",
	"1113":
		"Compra para comercialização, de mercadoria recebida anteriormente em consignação mercantil",
	"1116":
		"Compra para industrialização ou produção rural originada de encomenda para recebimento futuro",
	"1117": "Compra para comercialização originada de encomenda para recebimento futuro",
	"1118":
		"Compra de mercadoria para comercialização pelo adquirente originário, entregue pelo vendedor remetente ao destinatário, em venda à ordem",
	"1120":
		"Compra para industrialização ou produção rural, em venda à ordem, já recebida do vendedor remetente",
	"1121": "Compra para comercialização, em venda à ordem, já recebida do vendedor remetente",
	"1122":
		"Compra para industrialização em que a mercadoria foi remetida pelo fornecedor ao industrializador sem transitar pelo estabelecimento adquirente",
	"1124": "Industrialização efetuada por outra empresa",
	"1125":
		"Industrialização efetuada por outra empresa quando a mercadoria remetida para utilização no processo de industrialização não transitou pelo estabelecimento adquirente da mercadoria",
	"1126": "Compra para utilização na prestação de serviço sujeita ao ICMS",
	"1128": "Compra para utilização na prestação de serviço sujeita ao ISSQN",
	"1131":
		"Entrada de mercadoria, com previsão de posterior ajuste ou fixação de preço, em ato cooperativo",
	"1132":
		"Fixação de preço de produção do estabelecimento produtor, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço, em ato cooperativo, para comercialização",
	"1135":
		"Fixação de preço de produção do estabelecimento produtor, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço, em ato cooperativo, para industrialização",
	"1151": "Transferência para industrialização ou produção rural",
	"1152": "Transferência para comercialização",
	"1153": "Transferência de energia elétrica para distribuição",
	"1154": "Transferência para utilização na prestação de serviço",
	"1159": "Entrada decorrente do fornecimento de produto ou mercadoria em ato cooperativo",
	"1201": "Devolução de venda de produção do estabelecimento",
	"1202":
		"Devolução de venda de mercadoria adquirida ou recebida de terceiros, ou qualquer devolução de mercadoria efetuada pelo MEI com exceção das classificadas nos códigos 1.503, 1.504, 1.505 e 1.506",
	"1203":
		"Devolução de venda de produção do estabelecimento, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio",
	"1204":
		"Devolução de venda de mercadoria adquirida ou recebida de terceiros, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio",
	"1205": "Anulação de valor relativo à prestação de serviço de comunicação",
	"1206": "Anulação de valor relativo à prestação de serviço de transporte",
	"1207": "Anulação de valor relativo à venda de energia elétrica",
	"1208": "Devolução de produção do estabelecimento, remetida em transferência",
	"1209": "Devolução de mercadoria adquirida ou recebida de terceiros, remetida em transferência",
	"1212":
		"Devolução de venda no mercado interno de mercadoria industrializada e insumo importado sob o Regime Aduaneiro Especial de Entreposto Industrial sob Controle Informatizado do Sistema Público de Escrituração Digital (Recof-Sped)",
	"1213":
		"Devolução de remessa de produção do estabelecimento, com previsão de posterior ajuste ou fixação de preço, em ato cooperativo",
	"1214":
		"Devolução referente à fixação de preço de produção do estabelecimento produtor em ato cooperativo",
	"1215": "Devolução de fornecimento de produção do estabelecimento em ato cooperativo",
	"1216":
		"Devolução de fornecimento de mercadoria adquirida ou recebida de terceiros em ato cooperativo",
	"1251": "Compra de energia elétrica para distribuição ou comercialização",
	"1252": "Compra de energia elétrica por estabelecimento industrial",
	"1253": "Compra de energia elétrica por estabelecimento comercial",
	"1254": "Compra de energia elétrica por estabelecimento prestador de serviço de transporte",
	"1255": "Compra de energia elétrica por estabelecimento prestador de serviço de comunicação",
	"1256": "Compra de energia elétrica por estabelecimento de produtor rural",
	"1257": "Compra de energia elétrica para consumo por demanda contratada",
	"1301": "Aquisição de serviço de comunicação para execução de serviço da mesma natureza",
	"1302": "Aquisição de serviço de comunicação por estabelecimento industrial",
	"1303": "Aquisição de serviço de comunicação por estabelecimento comercial",
	"1304":
		"Aquisição de serviço de comunicação por estabelecimento de prestador de serviço de transporte",
	"1305":
		"Aquisição de serviço de comunicação por estabelecimento de geradora ou de distribuidora de energia elétrica",
	"1306": "Aquisição de serviço de comunicação por estabelecimento de produtor rural",
	"1351": "Aquisição de serviço de transporte para execução de serviço da mesma natureza",
	"1352": "Aquisição de serviço de transporte por estabelecimento industrial",
	"1353": "Aquisição de serviço de transporte por estabelecimento comercial",
	"1354":
		"Aquisição de serviço de transporte por estabelecimento de prestador de serviço de comunicação",
	"1355":
		"Aquisição de serviço de transporte por estabelecimento de geradora ou de distribuidora de energia elétrica",
	"1356": "Aquisição de serviço de transporte por estabelecimento de produtor rural",
	"1360":
		"Aquisição de serviço de transporte por contribuinte substituto em relação ao serviço de transporte",
	"1401":
		"Compra para industrialização ou produção rural em operação com mercadoria sujeita ao regime de substituição tributária",
	"1403":
		"Compra para comercialização em operação com mercadoria sujeita ao regime de substituição tributária",
	"1406":
		"Compra de bem para o ativo imobilizado cuja mercadoria está sujeita ao regime de substituição tributária",
	"1407":
		"Compra de mercadoria para uso ou consumo cuja mercadoria está sujeita ao regime de substituição tributária",
	"1408":
		"Transferência para industrialização ou produção rural em operação com mercadoria sujeita ao regime de substituição tributária",
	"1409":
		"Transferência para comercialização em operação com mercadoria sujeita ao regime de substituição tributária",
	"1410":
		"Devolução de venda de produção do estabelecimento em operação com produto sujeito ao regime de substituição tributária",
	"1411":
		"Devolução de venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária",
	"1414":
		"Retorno de produção do estabelecimento, remetida para venda fora do estabelecimento em operação com produto sujeito ao regime de substituição tributária",
	"1415":
		"Retorno de mercadoria adquirida ou recebida de terceiros, remetida para venda fora do estabelecimento em operação com mercadoria sujeita ao regime de substituição tributária",
	"1451": "Entrada de animal - Sistema de Integração e Parceria Rural",
	"1452": "Entrada de insumo - Sistema de Integração e Parceria Rural",
	"1453": "Retorno do animal ou da produção - Sistema de Integração e Parceria Rural",
	"1454": "Retorno simbólico do animal ou da produção - Sistema de Integração e Parceria Rural",
	"1455": "Retorno de insumo não utilizado na produção - Sistema de Integração e Parceria Rural",
	"1456": "Entrada referente à remuneração do produtor no Sistema de Integração e Parceria Rural",
	"1501": "Entrada de mercadoria recebida com fim específico de exportação",
	"1503":
		"Entrada decorrente de devolução de produto remetido com fim específico de exportação, de produção do estabelecimento",
	"1504":
		"Entrada decorrente de devolução, inclusive simbólica, de mercadoria remetida com fim específico de exportação, adquirida ou recebida de terceiros",
	"1505":
		"Entrada decorrente de devolução, inclusive simbólica, de mercadorias remetidas para formação de lote de exportação, de produtos industrializados ou produzidos pelo próprio estabelecimento",
	"1506":
		"Entrada decorrente de devolução, inclusive simbólica, de mercadorias adquiridas ou recebidas de terceiros, remetidas para formação de lote de exportação",
	"1551": "Compra de bem para o ativo imobilizado",
	"1552": "Transferência de bem do ativo imobilizado",
	"1553": "Devolução de venda de bem do ativo imobilizado",
	"1554": "Retorno de bem do ativo imobilizado remetido para uso fora do estabelecimento",
	"1555": "Entrada de bem do ativo imobilizado de terceiro, remetido para uso no estabelecimento",
	"1556": "Compra de material para uso ou consumo",
	"1557": "Transferência de material para uso ou consumo",
	"1601": "Recebimento, por transferência, de crédito de ICMS",
	"1602":
		"Recebimento, por transferência, de saldo credor de ICMS de outro estabelecimento da mesma empresa, para compensação de saldo devedor de ICMS",
	"1603": "Ressarcimento de ICMS retido por substituição tributária",
	"1604": "Lançamento do crédito relativo à compra de bem para o ativo imobilizado",
	"1605":
		"Recebimento, por transferência, de saldo devedor de ICMS de outro estabelecimento da mesma empresa",
	"1651": "Compra de combustíveis ou lubrificantes para industrialização subsequente",
	"1652": "Compra de combustíveis ou lubrificantes para comercialização",
	"1653": "Compra de combustíveis ou lubrificantes por consumidor ou usuário final",
	"1657": "Retorno de remessa de combustíveis ou lubrificantes para venda fora do estabelecimento",
	"1658": "Transferência de combustíveis ou lubrificantes para industrialização",
	"1659": "Transferência de combustíveis ou lubrificantes para comercialização",
	"1660":
		"Devolução de venda de combustíveis ou lubrificantes destinados à industrialização subsequente",
	"1661": "Devolução de venda de combustíveis ou lubrificantes destinados à comercialização",
	"1662":
		"Devolução de venda de combustíveis ou lubrificantes destinados a consumidor ou usuário final",
	"1663": "Entrada de combustíveis ou lubrificantes para armazenagem",
	"1664": "Retorno de combustíveis ou lubrificantes remetidos para armazenagem",
	"1901": "Entrada para industrialização por encomenda",
	"1902": "Retorno de mercadoria remetida para industrialização por encomenda",
	"1903":
		"Entrada de mercadoria remetida para industrialização e não aplicada no referido processo",
	"1904":
		"Retorno de remessa para venda fora do estabelecimento, ou qualquer entrada e retorno de remessa efetuada pelo MEI com exceção dos classificados nos códigos 1.202, 1.503, 1.504, 1.505 e 1.506",
	"1905":
		"Entrada de mercadoria recebida para depósito em depósito fechado, armazém geral ou outro estabelecimentoda mesma empresa ou de terceiro",
	"1906":
		"Retorno de mercadoria remetida para depósito fechado, armazém geral ou outro estabelecimento, da mesma empresa ou de terceiro",
	"1907":
		"Retorno simbólico de mercadoria remetida para depósito fechado, armazém geral ou outro estabelecimento da mesma empresa ou de terceiro",
	"1908": "Entrada de bem por conta de contrato de comodato ou locação",
	"1909": "Retorno de bem remetido por conta de contrato de comodato ou locação",
	"1910": "Entrada de bonificação, doação ou brinde",
	"1911": "Entrada de amostra grátis",
	"1912": "Entrada de mercadoria ou bem recebido para demonstração ou mostruário",
	"1913": "Retorno de mercadoria ou bem remetido para demonstração, mostruário ou treinamento",
	"1914": "Retorno de mercadoria ou bem remetido para exposição ou feira",
	"1915": "Entrada de mercadoria ou bem recebido para conserto ou reparo",
	"1916": "Retorno de mercadoria ou bem remetido para conserto ou reparo",
	"1917": "Entrada de mercadoria recebida em consignação mercantil ou industrial",
	"1918": "Devolução de mercadoria remetida em consignação mercantil ou industrial",
	"1919":
		"Devolução simbólica de mercadoria vendida ou utilizada em processo industrial, remetida anteriormente em consignação mercantil ou industrial",
	"1920": "Entrada de embalagens, bombonas, vasilhames, sacarias, pallets ou assemelhados",
	"1921": "Retorno de embalagens, bombonas, vasilhames, sacarias, pallets ou assemelhados",
	"1922":
		"Lançamento efetuado a título de simples faturamento decorrente de compra para recebimento futuro",
	"1923": "Entrada de mercadoria recebida do vendedor remetente, em venda à ordem",
	"1924":
		"Entrada para industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente",
	"1925":
		"Retorno de mercadoria remetida para industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente",
	"1926":
		"Lançamento efetuado a título de reclassificação de mercadoria decorrente de formação de kit ou de sua desagregação",
	"1931":
		"Lançamento efetuado pelo tomador do serviço de transporte quando a responsabilidade de retenção do imposto for atribuída ao remetente ou alienante da mercadoria, pelo serviço de transporte realizado por transportador autônomo ou por transportador não inscrito na unidade da Federação onde iniciado o serviço",
	"1932":
		"Aquisição de serviço de transporte iniciado em unidade da Federação diversa daquela onde inscrito o prestador",
	"1933": "Aquisição de serviço sujeito ao ISSQN",
	"1934":
		"Entrada simbólica de mercadoria recebida para depósito em depósito fechado ou armazém geral",
	"1949": "Outra entrada de mercadoria ou prestação de serviço não especificada",
	"2101": "Compra para industrialização ou produção rural",
	"2102": "Compra para comercialização",
	"2111":
		"Compra para industrialização de mercadoria recebida anteriormente em consignação industrial",
	"2113":
		"Compra para comercialização, de mercadoria recebida anteriormente em consignação mercantil",
	"2116":
		"Compra para industrialização ou produção rural originada de encomenda para recebimento futuro",
	"2117": "Compra para comercialização originada de encomenda para recebimento futuro",
	"2118":
		"Compra de mercadoria para comercialização pelo adquirente originário, entregue pelo vendedor remetente ao destinatário, em venda à ordem",
	"2120":
		"Compra para industrialização ou produção rural, em venda à ordem, já recebida do vendedor remetente",
	"2121": "Compra para comercialização, em venda à ordem, já recebida do vendedor remetente",
	"2122":
		"Compra para industrialização em que a mercadoria foi remetida pelo fornecedor ao industrializador sem transitar pelo estabelecimento adquirente",
	"2124": "Industrialização efetuada por outra empresa",
	"2125":
		"Industrialização efetuada por outra empresa quando a mercadoria remetida para utilização no processo de industrialização não transitou pelo estabelecimento adquirente da mercadoria",
	"2126": "Compra para utilização na prestação de serviço sujeita ao ICMS",
	"2128": "Compra para utilização na prestação de serviço sujeita ao ISSQN",
	"2131":
		"Entrada de mercadoria, com previsão de posterior ajuste ou fixação de preço, em ato cooperativo",
	"2132":
		"Fixação de preço de produção do estabelecimento produtor, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço, em ato cooperativo, para comercialização",
	"2135":
		"Fixação de preço de produção do estabelecimento produtor, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço, em ato cooperativo, para industrialização",
	"2151": "Transferência para industrialização ou produção rural",
	"2152": "Transferência para comercialização",
	"2153": "Transferência de energia elétrica para distribuição",
	"2154": "Transferência para utilização na prestação de serviço",
	"2159": "Entrada decorrente do fornecimento de produto ou mercadoria em ato cooperativo",
	"2201": "Devolução de venda de produção do estabelecimento",
	"2202":
		"Devolução de venda de mercadoria adquirida ou recebida de terceiros, ou qualquer devolução de mercadoria efetuada pelo MEI com exceção das classificadas nos códigos 2.503, 2.504, 2.505 e 2.506",
	"2203":
		"Devolução de venda de produção do estabelecimento, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio",
	"2204":
		"Devolução de venda de mercadoria adquirida ou recebida de terceiros, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio",
	"2205": "Anulação de valor relativo à prestação de serviço de comunicação",
	"2206": "Anulação de valor relativo à prestação de serviço de transporte",
	"2207": "Anulação de valor relativo à venda de energia elétrica",
	"2208": "Devolução de produção do estabelecimento, remetida em transferência",
	"2209": "Devolução de mercadoria adquirida ou recebida de terceiros, remetida em transferência",
	"2212":
		"Devolução de venda no mercado interno de mercadoria industrializada e insumo importado sob o Regime Aduaneiro Especial de Entreposto Industrial sob Controle Informatizado do Sistema Público de Escrituração Digital (Recof-Sped)",
	"2213":
		"Devolução de remessa de produção do estabelecimento, com previsão de posterior ajuste ou fixação de preço, em ato cooperativo",
	"2214":
		"Devolução referente à fixação de preço de produção do estabelecimento produtor, em ato cooperativo",
	"2215": "Devolução de fornecimento de produção do estabelecimento em ato cooperativo",
	"2216":
		"Devolução de fornecimento de mercadoria adquirida ou recebida de terceiros em ato cooperativo",
	"2251": "Compra de energia elétrica para distribuição ou comercialização",
	"2252": "Compra de energia elétrica por estabelecimento industrial",
	"2253": "Compra de energia elétrica por estabelecimento comercial",
	"2254": "Compra de energia elétrica por estabelecimento prestador de serviço de transporte",
	"2255": "Compra de energia elétrica por estabelecimento prestador de serviço de comunicação",
	"2256": "Compra de energia elétrica por estabelecimento de produtor rural",
	"2257": "Compra de energia elétrica para consumo por demanda contratada",
	"2301": "Aquisição de serviço de comunicação para execução de serviço da mesma natureza",
	"2302": "Aquisição de serviço de comunicação por estabelecimento industrial",
	"2303": "Aquisição de serviço de comunicação por estabelecimento comercial",
	"2304":
		"Aquisição de serviço de comunicação por estabelecimento de prestador de serviço de transporte",
	"2305":
		"Aquisição de serviço de comunicação por estabelecimento de geradora ou de distribuidora de energia elétrica",
	"2306": "Aquisição de serviço de comunicação por estabelecimento de produtor rural",
	"2351": "Aquisição de serviço de transporte para execução de serviço da mesma natureza",
	"2352": "Aquisição de serviço de transporte por estabelecimento industrial",
	"2353": "Aquisição de serviço de transporte por estabelecimento comercial",
	"2354":
		"Aquisição de serviço de transporte por estabelecimento de prestador de serviço de comunicação",
	"2355":
		"Aquisição de serviço de transporte por estabelecimento de geradora ou de distribuidora de energia elétrica",
	"2356": "Aquisição de serviço de transporte por estabelecimento de produtor rural",
	"2401":
		"Compra para industrialização ou produção rural em operação com mercadoria sujeita ao regime de substituição tributária",
	"2403":
		"Compra para comercialização em operação com mercadoria sujeita ao regime de substituição tributária",
	"2406":
		"Compra de bem para o ativo imobilizado cuja mercadoria está sujeita ao regime de substituição tributária",
	"2407":
		"Compra de mercadoria para uso ou consumo cuja mercadoria está sujeita ao regime de substituição tributária",
	"2408":
		"Transferência para industrialização ou produção rural em operação com mercadoria sujeita ao regime de substituição tributária",
	"2409":
		"Transferência para comercialização em operação com mercadoria sujeita ao regime de substituição tributária",
	"2410":
		"Devolução de venda de produção do estabelecimento em operação com produto sujeito ao regime de substituição tributária",
	"2411":
		"Devolução de venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária",
	"2414":
		"Retorno de produção do estabelecimento, remetida para venda fora do estabelecimento em operação com produto sujeito ao regime de substituição tributária",
	"2415":
		"Retorno de mercadoria adquirida ou recebida de terceiros, remetida para venda fora do estabelecimento em operação com mercadoria sujeita ao regime de substituição tributária",
	"2451": "Entrada de animal - Sistema de Integração e Parceria Rural",
	"2452": "Entrada de insumo - Sistema de Integração e Parceria Rural",
	"2453": "Retorno do animal ou da produção - Sistema de Integração e Parceria Rural",
	"2454": "Retorno simbólico do animal ou da produção - Sistema de Integração e Parceria Rural",
	"2455": "Retorno de insumo não utilizado na produção - Sistema de Integração e Parceria Rural",
	"2456": "Entrada referente à remuneração do produtor no Sistema de Integração e Parceria Rural",
	"2501": "Entrada de mercadoria recebida com fim específico de exportação",
	"2503":
		"Entrada decorrente de devolução de produto remetido com fim específico de exportação, de produção do estabelecimento",
	"2504":
		"Entrada decorrente de devolução, inclusive simbólica, de mercadoria remetida com fim específico de exportação, adquirida ou recebida de terceiros",
	"2505":
		"Entrada decorrente de devolução, inclusive simbólica, de mercadorias remetidas para formação de lote de exportação, de produtos industrializados ou produzidos pelo próprio estabelecimento",
	"2506":
		"Entrada decorrente de devolução, inclusive simbólica, de mercadorias adquiridas ou recebidas de terceiros, remetidas para formação de lote de exportação",
	"2551": "Compra de bem para o ativo imobilizado",
	"2552": "Transferência de bem do ativo imobilizado",
	"2553": "Devolução de venda de bem do ativo imobilizado",
	"2554": "Retorno de bem do ativo imobilizado remetido para uso fora do estabelecimento",
	"2555": "Entrada de bem do ativo imobilizado de terceiro, remetido para uso no estabelecimento",
	"2556": "Compra de material para uso ou consumo",
	"2557": "Transferência de material para uso ou consumo",
	"2603": "Ressarcimento de ICMS retido por substituição tributária",
	"2651": "Compra de combustíveis ou lubrificantes para industrialização subsequente",
	"2652": "Compra de combustíveis ou lubrificantes para comercialização",
	"2653": "Compra de combustíveis ou lubrificantes por consumidor ou usuário final",
	"2657": "Retorno de remessa de combustíveis ou lubrificantes para venda fora do estabelecimento",
	"2658": "Transferência de combustíveis ou lubrificantes para industrialização",
	"2659": "Transferência de combustíveis ou lubrificantes para comercialização",
	"2660":
		"Devolução de venda de combustíveis ou lubrificantes destinados à industrialização subsequente",
	"2661": "Devolução de venda de combustíveis ou lubrificantes destinados à comercialização",
	"2662":
		"Devolução de venda de combustíveis ou lubrificantes destinados a consumidor ou usuário final",
	"2663": "Entrada de combustíveis ou lubrificantes para armazenagem",
	"2664": "Retorno de combustíveis ou lubrificantes remetidos para armazenagem",
	"2901": "Entrada para industrialização por encomenda",
	"2902": "Retorno de mercadoria remetida para industrialização por encomenda",
	"2903":
		"Entrada de mercadoria remetida para industrialização e não aplicada no referido processo",
	"2904":
		"Retorno de remessa para venda fora do estabelecimento, ou qualquer entrada e retorno de remessa efetuada pelo MEI com exceção dos classificados nos códigos 2.202, 2.503, 2.504, 2.505 e 2.506",
	"2905":
		"Entrada de mercadoria recebida para depósito em depósito fechado, armazém geral ou outro estabelecimento da mesma empresa ou de terceiro",
	"2906":
		"Retorno de mercadoria remetida para depósito fechado, armazém geral ou outro estabelecimento da mesma empresa ou de terceiro",
	"2907":
		"Retorno simbólico de mercadoria remetida para depósito fechado, armazém geral ou outro estabelecimento da mesma empresa ou de terceiro",
	"2908": "Entrada de bem por conta de contrato de comodato ou locação",
	"2909": "Retorno de bem remetido por conta de contrato de comodato ou locação",
	"2910": "Entrada de bonificação, doação ou brinde",
	"2911": "Entrada de amostra grátis",
	"2912": "Entrada de mercadoria ou bem recebido para demonstração ou mostruário",
	"2913": "Retorno de mercadoria ou bem remetido para demonstração, mostruário ou treinamento",
	"2914": "Retorno de mercadoria ou bem remetido para exposição ou feira",
	"2915": "Entrada de mercadoria ou bem recebido para conserto ou reparo",
	"2916": "Retorno de mercadoria ou bem remetido para conserto ou reparo",
	"2917": "Entrada de mercadoria recebida em consignação mercantil ou industrial",
	"2918": "Devolução de mercadoria remetida em consignação mercantil ou industrial",
	"2919":
		"Devolução simbólica de mercadoria vendida ou utilizada em processo industrial, remetida anteriormente em consignação mercantil ou industrial",
	"2920": "Entrada de embalagens, bombonas, vasilhames, sacarias, pallets ou assemelhados",
	"2921": "Retorno de embalagens, bombonas, vasilhames, sacarias, pallets ou assemelhados",
	"2922":
		"Lançamento efetuado a título de simples faturamento decorrente de compra para recebimento futuro",
	"2923": "Entrada de mercadoria recebida do vendedor remetente, em venda à ordem",
	"2924":
		"Entrada para industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente",
	"2925":
		"Retorno de mercadoria remetida para industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente",
	"2931":
		"Lançamento efetuado pelo tomador do serviço de transporte quando a responsabilidade de retenção do imposto for atribuída ao remetente ou alienante da mercadoria, pelo serviço de transporte realizado por transportador autônomo ou por transportador não inscrito na unidade da Federação onde iniciado o serviço",
	"2932":
		"Aquisição de serviço de transporte iniciado em unidade da Federação diversa daquela onde inscrito o prestador",
	"2933": "Aquisição de serviço sujeito ao ISSQN",
	"2934":
		"Entrada simbólica de mercadoria recebida para depósito em depósito fechado ou armazém geral",
	"2949": "Outra entrada de mercadoria ou prestação de serviço não especificada",
	"3101": "Compra para industrialização ou produção rural",
	"3102": "Compra para comercialização",
	"3126": "Compra para utilização na prestação de serviço sujeita ao ICMS",
	"3127": "Compra para industrialização sob o regime de “drawback”",
	"3128": "Compra para utilização na prestação de serviço sujeita ao ISSQN",
	"3129":
		"Compra para industrialização sob o Regime Aduaneiro Especial de Entreposto Industrial sob Controle Informatizado do Sistema Público de Escrituração Digital (Recof-Sped)",
	"3201": "Devolução de venda de produção do estabelecimento",
	"3202": "Devolução de venda de mercadoria adquirida ou recebida de terceiros",
	"3205": "Anulação de valor relativo à prestação de serviço de comunicação",
	"3206": "Anulação de valor relativo à prestação de serviço de transporte",
	"3207": "Anulação de valor relativo à venda de energia elétrica",
	"3211": "Devolução de venda de produção do estabelecimento sob o regime de “drawback”",
	"3212":
		"Devolução de venda no mercado externo de mercadoria industrializada sob o Regime Aduaneiro Especial de Entreposto Industrial sob Controle Informatizado do Sistema Público de Escrituração Digital (Recof-Sped)",
	"3251": "Compra de energia elétrica para distribuição ou comercialização",
	"3301": "Aquisição de serviço de comunicação para execução de serviço da mesma natureza",
	"3351": "Aquisição de serviço de transporte para execução de serviço da mesma natureza",
	"3352": "Aquisição de serviço de transporte por estabelecimento industrial",
	"3353": "Aquisição de serviço de transporte por estabelecimento comercial",
	"3354":
		"Aquisição de serviço de transporte por estabelecimento de prestador de serviço de comunicação",
	"3355":
		"Aquisição de serviço de transporte por estabelecimento de geradora ou de distribuidora de energia elétrica",
	"3356": "Aquisição de serviço de transporte por estabelecimento de produtor rural",
	"3503":
		"Devolução de mercadoria exportada que tenha sido recebida com fim específico de exportação",
	"3551": "Compra de bem para o ativo imobilizado",
	"3552":
		"Entrada de produto destinado para uso ou consumo de bordo, em embarcações ou aeronaves exclusivamente em tráfego internacional com destino ao exterior",
	"3553": "Devolução de venda de bem do ativo imobilizado",
	"3556": "Compra de material para uso ou consumo",
	"3651": "Compra de combustíveis ou lubrificantes para industrialização subsequente",
	"3652": "Compra de combustíveis ou lubrificantes para comercialização",
	"3653": "Compra de combustíveis ou lubrificantes por consumidor ou usuário final",
	"3667":
		"Entrada de combustíveis ou lubrificantes para consumo final, em embarcações ou aeronaves exclusivamente em tráfego internacional com destino ao exterior",
	"3930":
		"Lançamento efetuado a título de entrada de bem sob amparo de regime especial aduaneiro de admissão temporária",
	"3949": "Outra entrada de mercadoria ou prestação de serviço não especificada",
	"5101": "Venda de produção do estabelecimento",
	"5102":
		"Venda de mercadoria adquirida ou recebida de terceiros, ou qualquer venda de mercadoria efetuada pelo MEI com exceção das saídas classificadas nos códigos 5.501, 5.502, 5.504 e 5.505",
	"5103": "Venda de produção do estabelecimento, efetuada fora do estabelecimento",
	"5104":
		"Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento",
	"5105": "Venda de produção do estabelecimento que não deva por ele transitar",
	"5106": "Venda de mercadoria adquirida ou recebida de terceiros, que não deva por ele transitar",
	"5109":
		"Venda de produção do estabelecimento, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio",
	"5110":
		"Venda de mercadoria adquirida ou recebida de terceiros, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio",
	"5111": "Venda de produção do estabelecimento remetida anteriormente em consignação industrial",
	"5112":
		"Venda de mercadoria adquirida ou recebida de terceiros remetida anteriormente em consignação industrial",
	"5113": "Venda de produção do estabelecimento remetida anteriormente em consignação mercantil",
	"5114":
		"Venda de mercadoria adquirida ou recebida de terceiros remetida anteriormente em consignação mercantil",
	"5115":
		"Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil",
	"5116": "Venda de produção do estabelecimento originada de encomenda para entrega futura",
	"5117":
		"Venda de mercadoria adquirida ou recebida de terceiros, originada de encomenda para entrega futura",
	"5118":
		"Venda de produção do estabelecimento industrial ou rural, entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem",
	"5119":
		"Venda de mercadoria adquirida ou recebida de terceiros entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem",
	"5120":
		"Venda de mercadoria adquirida ou recebida de terceiros entregue ao destinatário pelo vendedor remetente, em venda à ordem",
	"5122":
		"Venda de produção do estabelecimento remetida para industrialização, por conta e ordem do adquirente, sem transitar pelo estabelecimento do adquirente",
	"5123":
		"Venda de mercadoria adquirida ou recebida de terceiros remetida para industrialização, por conta e ordem do adquirente, sem transitar pelo estabelecimento do adquirente",
	"5124": "Industrialização efetuada para outra empresa",
	"5125":
		"Industrialização efetuada para outra empresa quando a mercadoria recebida para utilização no processo de industrialização não transitar pelo estabelecimento adquirente da mercadoria",
	"5129":
		"Venda de mercadoria industrializada e de insumo importado sob o amparo do Regime Aduaneiro Especial de Entreposto Industrial sob Controle Informatizado do Sistema Público de Escrituração Digital (Recof-Sped)",
	"5131":
		"Remessa de produção do estabelecimento, com previsão de posterior ajuste ou fixação de preço, em ato cooperativo",
	"5132":
		"Fixação de preço de produção do estabelecimento, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço, em ato cooperativo",
	"5151": "Transferência de produção do estabelecimento",
	"5152": "Transferência de mercadoria adquirida ou recebida de terceiros",
	"5153": "Transferência de energia elétrica",
	"5155":
		"Transferência de produção do estabelecimento para depósito em depósito fechado, armazém geral ou outro estabelecimento da mesma empresa ou de terceiro, que não deva por ele transitar",
	"5156":
		"Transferência de mercadoria adquirida ou recebida de terceiros para depósito em depósito fechado, armazém geral ou outro estabelecimento da mesma empresa ou de terceiro, que não deva por ele transitar",
	"5159": "Fornecimento de produção do estabelecimento em ato cooperativo",
	"5160": "Fornecimento de mercadoria adquirida ou recebida de terceiros em ato cooperativo",
	"5201": "Devolução de compra para industrialização ou produção rural",
	"5202":
		"Devolução de compra para comercialização, ou qualquer devolução de mercadorias efetuada pelo MEI com exceção das classificadas no código 5.503",
	"5205": "Anulação de valor relativo à aquisição de serviço de comunicação",
	"5206": "Anulação de valor relativo à aquisição de serviço de transporte",
	"5207": "Anulação de valor relativo à compra de energia elétrica",
	"5208":
		"Devolução de mercadoria recebida em transferência para industrialização ou produção rural",
	"5209": "Devolução de mercadoria recebida em transferência para comercialização",
	"5210": "Devolução de compra para utilização na prestação de serviço",
	"5213":
		"Devolução de entrada, inclusive simbólica, de mercadoria com previsão de posterior ajuste ou fixação de preço, em ato cooperativo",
	"5214":
		"Devolução referente à fixação de preço de produção do estabelecimento produtor, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço, em ato cooperativo, para comercialização",
	"5215":
		"Devolução referente à fixação de preço de produção do estabelecimento produtor, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço, em ato cooperativo, para industrialização",
	"5216":
		"Devolução de entrada decorrente do fornecimento de produto ou mercadoria em ato cooperativo",
	"5251": "Venda de energia elétrica para distribuição ou comercialização",
	"5252": "Venda de energia elétrica para estabelecimento industrial",
	"5253": "Venda de energia elétrica para estabelecimento comercial",
	"5254": "Venda de energia elétrica para estabelecimento prestador de serviço de transporte",
	"5255": "Venda de energia elétrica para estabelecimento prestador de serviço de comunicação",
	"5256": "Venda de energia elétrica para estabelecimento de produtor rural",
	"5257": "Venda de energia elétrica para consumo por demanda contratada",
	"5258": "Venda de energia elétrica a não contribuinte",
	"5301": "Prestação de serviço de comunicação para execução de serviço da mesma natureza",
	"5302": "Prestação de serviço de comunicação a estabelecimento industrial",
	"5303": "Prestação de serviço de comunicação a estabelecimento comercial",
	"5304":
		"Prestação de serviço de comunicação a estabelecimento de prestador de serviço de transporte",
	"5305":
		"Prestação de serviço de comunicação a estabelecimento de geradora ou de distribuidora de energia elétrica",
	"5306": "Prestação de serviço de comunicação a estabelecimento de produtor rural",
	"5307": "Prestação de serviço de comunicação a não contribuinte",
	"5351": "Prestação de serviço de transporte para execução de serviço da mesma natureza",
	"5352": "Prestação de serviço de transporte a estabelecimento industrial",
	"5353": "Prestação de serviço de transporte a estabelecimento comercial",
	"5354":
		"Prestação de serviço de transporte a estabelecimento de prestador de serviço de comunicação",
	"5355":
		"Prestação de serviço de transporte a estabelecimento de geradora ou de distribuidora de energia elétrica",
	"5356": "Prestação de serviço de transporte a estabelecimento de produtor rural",
	"5357": "Prestação de serviço de transporte a não contribuinte",
	"5359":
		"Prestação de serviço de transporte a contribuinte ou a não contribuinte quando a mercadoria transportada está dispensada de emissão de nota fiscal",
	"5360":
		"Prestação de serviço de transporte a contribuinte substituto em relação ao serviço de transporte",
	"5401":
		"Venda de produção do estabelecimento em operação com produto sujeito ao regime de substituição tributária, na condição de contribuinte substituto",
	"5402":
		"Venda de produção do estabelecimento de produto sujeito ao regime de substituição tributária, em operação entre contribuintes substitutos do mesmo produto",
	"5403":
		"Venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária, na condição de contribuinte substituto",
	"5405":
		"Venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária, na condição de contribuinte substituído",
	"5408":
		"Transferência de produção do estabelecimento em operação com produto sujeito ao regime de substituição tributária",
	"5409":
		"Transferência de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária",
	"5410":
		"Devolução de compra para industrialização ou produção rural em operação com mercadoria sujeita ao regime de substituição tributária",
	"5411":
		"Devolução de compra para comercialização em operação com mercadoria sujeita ao regime de substituição tributária",
	"5412":
		"Devolução de bem do ativo imobilizado, em operação com mercadoria sujeita ao regime de substituição tributária",
	"5413":
		"Devolução de mercadoria destinada para uso ou consumo, em operação com mercadoria sujeita ao regime de substituição tributária",
	"5414":
		"Remessa de produção do estabelecimento para venda fora do estabelecimento em operação com produto sujeito ao regime de substituição tributária",
	"5415":
		"Remessa de mercadoria adquirida ou recebida de terceiros para venda fora do estabelecimento, em operação com mercadoria sujeita ao regime de substituição tributária",
	"5451": "Remessa de animal - Sistema de Integração e Parceria Rural",
	"5452": "Remessa de insumo - Sistema de Integração e Parceria Rural",
	"5453": "Retorno de animal ou da produção - Sistema de Integração e Parceria Rural",
	"5454": "Retorno simbólico de animal ou da produção - Sistema de Integração e Parceria Rural",
	"5455": "Retorno de insumos não utilizados na produção - Sistema de Integração e Parceria Rural",
	"5456": "Saída referente à remuneração do produtor - Sistema de Integração e Parceria Rural",
	"5501": "Remessa de produção do estabelecimento, com fim específico de exportação",
	"5502":
		"Remessa de mercadoria adquirida ou recebida de terceiros, com fim específico de exportação",
	"5503": "Devolução de mercadoria recebida com fim específico de exportação",
	"5504":
		"Remessa de mercadorias para formação de lote de exportação, de produtos industrializados ou produzidos pelo próprio estabelecimento",
	"5505":
		"Remessa de mercadorias, adquiridas ou recebidas de terceiros, para formação de lote de exportação",
	"5551": "Venda de bem do ativo imobilizado",
	"5552": "Transferência de bem do ativo imobilizado",
	"5553": "Devolução de compra de bem para o ativo imobilizado",
	"5554": "Remessa de bem do ativo imobilizado para uso fora do estabelecimento",
	"5555": "Devolução de bem do ativo imobilizado de terceiro, recebido para uso no estabelecimento",
	"5556": "Devolução de compra de material para uso ou consumo",
	"5557": "Transferência de material para uso ou consumo",
	"5601": "Transferência de crédito de ICMS acumulado",
	"5602":
		"Transferência de saldo credor de ICMS para outro estabelecimento da mesma empresa, destinado à compensação de saldo devedor de ICMS",
	"5603": "Ressarcimento de ICMS retido por substituição tributária",
	"5605": "Transferência de saldo devedor de ICMS de outro estabelecimento da mesma empresa",
	"5606": "Utilização de saldo credor de ICMS para extinção por compensação de débitos fiscais",
	"5651":
		"Venda de combustíveis ou lubrificantes de produção do estabelecimento destinados à industrialização subsequente",
	"5652":
		"Venda de combustíveis ou lubrificantes de produção do estabelecimento destinados à comercialização",
	"5653":
		"Venda de combustíveis ou lubrificantes de produção do estabelecimento destinados a consumidor ou usuário final",
	"5654":
		"Venda de combustíveis ou lubrificantes adquiridos ou recebidos de terceiros destinados à industrialização subsequente",
	"5655":
		"Venda de combustíveis ou lubrificantes adquiridos ou recebidos de terceiros destinados à comercialização",
	"5656":
		"Venda de combustíveis ou lubrificantes adquiridos ou recebidos de terceiros destinados a consumidor ou usuário final",
	"5657":
		"Remessa de combustíveis ou lubrificantes adquiridos ou recebidos de terceiros para venda fora do estabelecimento",
	"5658": "Transferência de combustíveis ou lubrificantes de produção do estabelecimento",
	"5659": "Transferência de combustíveis ou lubrificantes adquiridos ou recebidos de terceiro",
	"5660":
		"Devolução de compra de combustíveis ou lubrificantes adquiridos para industrialização subsequente",
	"5661": "Devolução de compra de combustíveis ou lubrificantes adquiridos para comercialização",
	"5662":
		"Devolução de compra de combustíveis ou lubrificantes adquiridos por consumidor ou usuário final",
	"5663": "Remessa para armazenagem de combustíveis ou lubrificantes",
	"5664": "Retorno de combustíveis ou lubrificantes recebidos para armazenagem",
	"5665": "Retorno simbólico de combustíveis ou lubrificantes recebidos para armazenagem",
	"5666":
		"Remessa por conta e ordem de terceiros de combustíveis ou lubrificantes recebidos para armazenagem",
	"5667":
		"Venda de combustíveis ou lubrificantes a consumidor ou usuário final estabelecido em outra unidade da Federação",
	"5901": "Remessa para industrialização por encomenda",
	"5902": "Retorno de mercadoria utilizada na industrialização por encomenda",
	"5903":
		"Retorno de mercadoria recebida para industrialização e não aplicada no referido processo",
	"5904":
		"Remessa para venda fora do estabelecimento, ou qualquer remessa efetuada pelo MEI com exceção das classificadas nos códigos 5.502 e 5.505",
	"5905":
		"Remessa para depósito fechado, armazém geral ou outro estabelecimento da mesma empresa ou de terceiro",
	"5906":
		"Retorno de mercadoria depositada em depósito fechado, armazém geral ou outro estabelecimento da mesma empresa ou de terceiro",
	"5907":
		"Retorno simbólico de mercadoria depositada em depósito fechado, armazém geral ou outro estabelecimento da mesma empresa ou de terceiro",
	"5908": "Remessa de bem por conta de contrato de comodato ou locação",
	"5909": "Retorno de bem recebido por conta de contrato de comodato ou locação",
	"5910": "Remessa em bonificação, doação ou brinde",
	"5911": "Remessa de amostra grátis",
	"5912": "Remessa de mercadoria ou bem para demonstração, mostruário ou treinamento",
	"5913": "Retorno de mercadoria ou bem recebido para demonstração ou mostruário",
	"5914": "Remessa de mercadoria ou bem para exposição ou feira",
	"5915": "Remessa de mercadoria ou bem para conserto ou reparo",
	"5916": "Retorno de mercadoria ou bem recebido para conserto ou reparo",
	"5917": "Remessa de mercadoria em consignação mercantil ou industrial",
	"5918": "Devolução de mercadoria recebida em consignação mercantil ou industrial",
	"5919":
		"Devolução simbólica de mercadoria vendida ou utilizada em processo industrial, recebida anteriormente em consignação mercantil ou industrial",
	"5920":
		"Remessa de embalagens, bombonas, vasilhames, sacarias, pallets, containers ou assemelhados",
	"5921":
		"Devolução de embalagens, bombonas, vasilhames, sacarias, pallets, containers ou assemelhados",
	"5922":
		"Lançamento efetuado a título de simples faturamento decorrente de venda para entrega futura",
	"5923":
		"Remessa de mercadoria por conta e ordem de terceiros, em venda à ordem ou em operações com armazém geral ou depósito fechado",
	"5924":
		"Remessa para industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente",
	"5925":
		"Retorno de mercadoria recebida para industrialização por conta e ordem do adquirente da mercadoria, quando aquela não transitar pelo estabelecimento do adquirente",
	"5926":
		"Lançamento efetuado a título de reclassificação de mercadoria decorrente de formação de kit ou de sua desagregação",
	"5927":
		"Lançamento efetuado a título de baixa de estoque decorrente de perda, roubo, deterioração",
	"5928":
		"Lançamento efetuado a título de baixa de estoque decorrente do encerramento da atividade do estabelecimento da empresa ou transferência por venda do fundo de comércio",
	"5929":
		"Lançamento efetuado em decorrência de emissão de documento fiscal relativo à operação ou prestação também acobertada por documento fiscal do varejo",
	"5931":
		"Lançamento efetuado em decorrência da responsabilidade de retenção do imposto por substituição tributária, atribuída ao remetente ou alienante da mercadoria, pelo serviço de transporte realizado por transportador autônomo ou por transportador não inscrito na unidade da Federação onde iniciado o serviço",
	"5932":
		"Prestação de serviço de transporte iniciada em unidade da Federação diversa daquela onde inscrito o prestador",
	"5933": "Prestação de serviço sujeita ao ISSQN",
	"5934": "Remessa simbólica de mercadoria depositada em armazém geral ou depósito fechado",
	"5949": "Outra saída de mercadoria ou prestação de serviço não especificada",
	"6101": "Venda de produção do estabelecimento",
	"6102":
		"Venda de mercadoria adquirida ou recebida de terceiros, ou qualquer venda de mercadoria efetuada pelo MEI com exceção das saídas classificadas nos códigos 6.501, 6.502, 6.504 e 6.505",
	"6103": "Venda de produção do estabelecimento, efetuada fora do estabelecimento",
	"6104":
		"Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento",
	"6105":
		"Venda de produção do estabelecimento armazenada em depósito fechado, armazém geral ou outro estabelecimento da mesma empresa ou de terceiro, que não deva por ele transitar",
	"6106":
		"Venda de mercadoria adquirida ou recebida de terceiros armazenada em depósito fechado, armazém geral ou outro estabelecimento da mesma empresa ou de terceiro, que não deva por ele transitar",
	"6107": "Venda de produção do estabelecimento, destinada a não contribuinte",
	"6108": "Venda de mercadoria adquirida ou recebida de terceiros, destinada a não contribuinte",
	"6109":
		"Venda de produção do estabelecimento, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio",
	"6110":
		"Venda de mercadoria adquirida ou recebida de terceiros, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio",
	"6111": "Venda de produção do estabelecimento remetida anteriormente em consignação industrial",
	"6112":
		"Venda de mercadoria adquirida ou recebida de Terceiros remetida anteriormente em consignação industrial",
	"6113": "Venda de produção do estabelecimento remetida anteriormente em consignação mercantil",
	"6114":
		"Venda de mercadoria adquirida ou recebida de terceiros remetida anteriormente em consignação mercantil",
	"6115":
		"Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil",
	"6116": "Venda de produção do estabelecimento originada de encomenda para entrega futura",
	"6117":
		"Venda de mercadoria adquirida ou recebida de terceiros, originada de encomenda para entrega futura",
	"6118":
		"Venda de produção do estabelecimento industrial ou rural, entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem",
	"6119":
		"Venda de mercadoria adquirida ou recebida de terceiros entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem",
	"6120":
		"Venda de mercadoria adquirida ou recebida de terceiros entregue ao destinatário pelo vendedor remetente, em venda à ordem",
	"6122":
		"Venda de produção do estabelecimento remetida para industrialização, por conta e ordem do adquirente, sem transitar pelo estabelecimento do adquirente",
	"6123":
		"Venda de mercadoria adquirida ou recebida de terceiros remetida para industrialização, por conta e ordem do adquirente, sem transitar pelo estabelecimento do adquirente",
	"6124": "Industrialização efetuada para outra empresa",
	"6125":
		"Industrialização efetuada para outra empresa quando a mercadoria recebida para utilização no processo de industrialização não transitar pelo estabelecimento adquirente da mercadoria",
	"6129":
		"Venda de mercadoria industrializada e de insumo importado sob o amparo do Regime Aduaneiro Especial de Entreposto Industrial sob Controle Informatizado do Sistema Público de Escrituração Digital (Recof-Sped)",
	"6131":
		"Remessa de produção do estabelecimento, com previsão de posterior ajuste ou fixação de preço, em ato cooperativo",
	"6132":
		"Fixação de preço de produção do estabelecimento, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço, em ato cooperativo",
	"6151": "Transferência de produção do estabelecimento",
	"6152": "Transferência de mercadoria adquirida ou recebida de terceiros",
	"6153": "Transferência de energia elétrica",
	"6155":
		"Transferência de produção do estabelecimento armazenada em depósito fechado, armazém geral ou outro estabelecimento da mesma empresa ou de terceiro, que não deva por ele transitar",
	"6156":
		"Transferência de mercadoria adquirida ou recebida de terceiros armazenada em depósito fechado, armazém geral ou outro estabelecimento da mesma empresa ou de terceiro, que não deva por ele transitar",
	"6159": "Fornecimento de produção do estabelecimento em ato cooperativo",
	"6160": "Fornecimento de mercadoria adquirida ou recebida de terceiros em ato cooperativo",
	"6201": "Devolução de compra para industrialização ou produção rural",
	"6202":
		"Devolução de compra para comercialização, ou qualquer devolução de mercadoria efetuada pelo MEI com exceção das classificadas no código 6.503",
	"6205": "Anulação de valor relativo à aquisição de serviço de comunicação",
	"6206": "Anulação de valor relativo à aquisição de serviço de transporte",
	"6207": "Anulação de valor relativo à compra de energia elétrica",
	"6208":
		"Devolução de mercadoria recebida em transferência para industrialização ou produção rural",
	"6209": "Devolução de mercadoria recebida em transferência para comercialização",
	"6210": "Devolução de compra para utilização na prestação de serviço",
	"6213":
		"Devolução de entrada, inclusive simbólica, de mercadoria, com previsão de posterior ajuste ou fixação de preço, em ato cooperativo",
	"6214":
		"Devolução referente à fixação de preço de produção do estabelecimento produtor, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço, em ato cooperativo, para comercialização",
	"6215":
		"Devolução referente à fixação de preço de produção do estabelecimento produtor, inclusive quando remetidas anteriormente com previsão de posterior ajuste ou fixação de preço, em ato cooperativo, para industrialização",
	"6216":
		"Devolução de entrada decorrente do fornecimento de produto ou mercadoria em ato cooperativo",
	"6251": "Venda de energia elétrica para distribuição ou comercialização",
	"6252": "Venda de energia elétrica para estabelecimento industrial",
	"6253": "Venda de energia elétrica para estabelecimento comercial",
	"6254": "Venda de energia elétrica para estabelecimento prestador de serviço de transporte",
	"6255": "Venda de energia elétrica para estabelecimento prestador de serviço de comunicação",
	"6256": "Venda de energia elétrica para estabelecimento de produtor rural",
	"6257": "Venda de energia elétrica para consumo por demanda contratada",
	"6258": "Venda de energia elétrica a não contribuinte",
	"6301": "Prestação de serviço de comunicação para execução de serviço da mesma natureza",
	"6302": "Prestação de serviço de comunicação a estabelecimento industrial",
	"6303": "Prestação de serviço de comunicação a estabelecimento comercial",
	"6304":
		"Prestação de serviço de comunicação a estabelecimento de prestador de serviço de transporte",
	"6305":
		"Prestação de serviço de comunicação a estabelecimento de geradora ou de distribuidora de energia elétrica",
	"6306": "Prestação de serviço de comunicação a estabelecimento de produtor rural",
	"6307": "Prestação de serviço de comunicação a não contribuinte",
	"6351": "Prestação de serviço de transporte para execução de serviço da mesma natureza",
	"6352": "Prestação de serviço de transporte a estabelecimento industrial",
	"6353": "Prestação de serviço de transporte a estabelecimento comercial",
	"6354":
		"Prestação de serviço de transporte a estabelecimento de prestador de serviço de comunicação",
	"6355":
		"Prestação de serviço de transporte a estabelecimento de geradora ou de distribuidora de energia elétrica",
	"6356": "Prestação de serviço de transporte a estabelecimento de produtor rural",
	"6357": "Prestação de serviço de transporte a não contribuinte",
	"6359":
		"Prestação de serviço de transporte a contribuinte ou a não contribuinte quando a mercadoria transportada está dispensada de emissão de nota fiscal",
	"6360":
		"Prestação de serviço de transporte a contribuinte substituto em relação ao serviço de transporte",
	"6401":
		"Venda de produção do estabelecimento em operação com produto sujeito ao regime de substituição tributária, na condição de contribuinte substituto",
	"6402":
		"Venda de produção do estabelecimento de produto sujeito ao regime de substituição tributária, em operação entre contribuintes substitutos do mesmo produto",
	"6403":
		"Venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária, na condição de contribuinte substituto",
	"6404":
		"Venda de mercadoria sujeita ao regime de substituição tributária, cujo imposto já tenha sido retido anteriormente",
	"6408":
		"Transferência de produção do estabelecimento em operação com produto sujeito ao regime de substituição tributária",
	"6409":
		"Transferência de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária",
	"6410":
		"Devolução de compra para industrialização ou produção rural em operação com mercadoria sujeita ao regime de substituição tributária",
	"6411":
		"Devolução de compra para comercialização em operação com mercadoria sujeita ao regime de substituição tributária",
	"6412":
		"Devolução de bem do ativo imobilizado, em operação com mercadoria sujeita ao regime de substituição tributária",
	"6413":
		"Devolução de mercadoria destinada para uso ou consumo, em operação com mercadoria sujeita ao regime de substituição tributária",
	"6414":
		"Remessa de produção do estabelecimento para venda fora do estabelecimento em operação com produto sujeito ao regime de substituição tributária",
	"6415":
		"Remessa de mercadoria adquirida ou recebida de terceiros para venda fora do estabelecimento, em operação com mercadoria sujeita ao regime de substituição tributária",
	"6451": "Remessa de animal - Sistema de Integração e Parceria Rural",
	"6452": "Remessa de insumo - Sistema de Integração e Parceria Rural",
	"6453": "Retorno de animal ou da produção - Sistema de Integração e Parceria Rural",
	"6454": "Retorno simbólico de animal ou da produção - Sistema de Integração e Parceria Rural",
	"6455": "Retorno de insumos não utilizados na produção - Sistema de Integração e Parceria Rural",
	"6456": "Saída referente à remuneração do produtor - Sistema de Integração e Parceria Rural",
	"6501": "Remessa de produção do estabelecimento, com fim específico de exportação",
	"6502":
		"Remessa de mercadoria adquirida ou recebida de terceiros, com fim específico de exportação",
	"6503": "Devolução de mercadoria recebida com fim específico de exportação",
	"6504":
		"Remessa de mercadorias para formação de lote de exportação, de produtos industrializados ou produzidos pelo próprio estabelecimento",
	"6505":
		"Remessa de mercadorias, adquiridas ou recebidas de terceiros, para formação de lote de exportação",
	"6551": "Venda de bem do ativo imobilizado",
	"6552": "Transferência de bem do ativo imobilizado",
	"6553": "Devolução de compra de bem para o ativo imobilizado",
	"6554": "Remessa de bem do ativo imobilizado para uso fora do estabelecimento",
	"6555": "Devolução de bem do ativo imobilizado de terceiro, recebido para uso no estabelecimento",
	"6556": "Devolução de compra de material para uso ou consumo",
	"6557": "Transferência de material para uso ou consumo",
	"6603": "Ressarcimento de ICMS retido por substituição tributária",
	"6651":
		"Venda de combustíveis ou lubrificantes de produção do estabelecimento destinados à industrialização subsequente",
	"6652":
		"Venda de combustíveis ou lubrificantes de produção do estabelecimento destinados à comercialização",
	"6653":
		"Venda de combustíveis ou lubrificantes de produção do estabelecimento destinados a consumidor ou usuário final",
	"6654":
		"Venda de combustíveis ou lubrificantes adquiridos ou recebidos de terceiros destinados à industrialização subsequente",
	"6655":
		"Venda de combustíveis ou lubrificantes adquiridos ou recebidos de terceiros destinados à comercialização",
	"6656":
		"Venda de combustíveis ou lubrificantes adquiridos ou recebidos de terceiros destinados a consumidor ou usuário final",
	"6657":
		"Remessa de combustíveis ou lubrificantes adquiridos ou recebidos de terceiros para venda fora do estabelecimento",
	"6658": "Transferência de combustíveis ou lubrificantes de produção do estabelecimento",
	"6659": "Transferência de combustíveis ou lubrificantes adquiridos ou recebidos de terceiro",
	"6660":
		"Devolução de compra de combustíveis ou lubrificantes adquiridos para industrialização subsequente",
	"6661": "Devolução de compra de combustíveis ou lubrificantes adquiridos para comercialização",
	"6662":
		"Devolução de compra de combustíveis ou lubrificantes adquiridos por consumidor ou usuário final",
	"6663": "Remessa para armazenagem de combustíveis ou lubrificantes",
	"6664": "Retorno de combustíveis ou lubrificantes recebidos para armazenagem",
	"6665": "Retorno simbólico de combustíveis ou lubrificantes recebidos para armazenagem",
	"6666":
		"Remessa por conta e ordem de terceiros de combustíveis ou lubrificantes recebidos para armazenagem",
	"6667":
		"Venda de combustíveis ou lubrificantes a consumidor ou usuário final estabelecido em outra unidade da Federação diferente da que ocorrer o consumo",
	"6901": "Remessa para industrialização por encomenda",
	"6902": "Retorno de mercadoria utilizada na industrialização por encomenda",
	"6903":
		"Retorno de mercadoria recebida para industrialização e não aplicada no referido processo",
	"6904":
		"Remessa para venda fora do estabelecimento, ou qualquer remessa efetuada pelo MEI com exceção das classificadas nos códigos 6.502 e 6.505",
	"6905":
		"Remessa para depósito fechado, armazém geral ou outro estabelecimento da mesma empresa ou de terceiro",
	"6906":
		"Retorno de mercadoria depositada em depósito fechado, armazém geral ou outro estabelecimento da mesma empresa ou de terceiro",
	"6907":
		"Retorno simbólico de mercadoria depositada em depósito fechado, armazém geral ou outro estabelecimento da mesma empresa ou de terceiro",
	"6908": "Remessa de bem por conta de contrato de comodato ou locação",
	"6909": "Retorno de bem recebido por conta de contrato de comodato ou locação",
	"6910": "Remessa em bonificação, doação ou brinde",
	"6911": "Remessa de amostra grátis",
	"6912": "Remessa de mercadoria ou bem para demonstração, mostruário ou treinamento",
	"6913": "Retorno de mercadoria ou bem recebido para demonstração ou mostruário",
	"6914": "Remessa de mercadoria ou bem para exposição ou feira",
	"6915": "Remessa de mercadoria ou bem para conserto ou reparo",
	"6916": "Retorno de mercadoria ou bem recebido para conserto ou reparo",
	"6917": "Remessa de mercadoria em consignação mercantil ou industrial",
	"6918": "Devolução de mercadoria recebida em consignação mercantil ou industrial",
	"6919":
		"Devolução simbólica de mercadoria vendida ou utilizada em processo industrial, recebida anteriormente em consignação mercantil ou industrial",
	"6920":
		"Remessa de embalagens, bombonas, vasilhames, sacarias, pallets, containers ou assemelhados",
	"6921":
		"Devolução de embalagens, bombonas, vasilhames, sacarias, pallets, containers ou assemelhados",
	"6922":
		"Lançamento efetuado a título de simples faturamento decorrente de venda para entrega futura",
	"6923":
		"Remessa de mercadoria por conta e ordem de terceiros, em venda à ordem ou em operações com armazém geral ou depósito fechado",
	"6924":
		"Remessa para industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente",
	"6925":
		"Retorno de mercadoria recebida para industrialização por conta e ordem do adquirente da mercadoria, quando aquela não transitar pelo estabelecimento do adquirente",
	"6929":
		"Lançamento efetuado em decorrência de emissão de documento fiscal relativo à operação ou prestação também acobertada por documento fiscal do varejo",
	"6931":
		"Lançamento efetuado em decorrência da responsabilidade de retenção do imposto por substituição tributária, atribuída ao remetente ou alienante da mercadoria, pelo serviço de transporte realizado por transportador autônomo ou por transportador não inscrito na unidade da Federação onde iniciado o serviço",
	"6932":
		"Prestação de serviço de transporte iniciada em unidade da Federação diversa daquela onde inscrito o prestador",
	"6933": "Prestação de serviço sujeita ao ISSQN",
	"6934": "Remessa simbólica de mercadoria depositada em armazém geral ou depósito fechado",
	"6949": "Outra saída de mercadoria ou prestação de serviço não especificada",
	"7101": "Venda de produção do estabelecimento",
	"7102": "Venda de mercadoria adquirida ou recebida de terceiros",
	"7105":
		"Venda de produção do estabelecimento armazenada em depósito fechado, armazém geral ou outro estabelecimento da mesma empresa ou de terceiro, que não deva por ele transitar",
	"7106":
		"Venda de mercadoria adquirida ou recebida de terceiros armazenada em depósito fechado, armazém geral ou outro estabelecimento da mesma empresa ou de terceiro, que não deva por ele transitar",
	"7127": "Venda de produção do estabelecimento sob o regime de “drawback”",
	"7129":
		"Venda de produção do estabelecimento ao mercado externo de mercadoria industrializada sob o amparo do Regime Aduaneiro Especial de Entreposto Industrial sob Controle Informatizado do Sistema Público de Escrituração Digital (Recof-Sped)",
	"7201": "Devolução de compra para industrialização ou produção rural",
	"7202": "Devolução de compra para comercialização",
	"7205": "Anulação de valor relativo à aquisição de serviço de comunicação",
	"7206": "Anulação de valor relativo à aquisição de serviço de transporte",
	"7207": "Anulação de valor relativo à compra de energia elétrica",
	"7210": "Devolução de compra para utilização na prestação de serviço",
	"7211": "Devolução de compras para industrialização sob o regime de “drawback”",
	"7212":
		"Devolução de compras para industrialização sob o regime de Regime Aduaneiro Especial de Entreposto Industrial sob Controle Informatizado do Sistema Público de Escrituração Digital (Recof-Sped)",
	"7251": "Venda de energia elétrica para o exterior",
	"7301": "Prestação de serviço de comunicação para execução de serviço da mesma natureza",
	"7358": "Prestação de serviço de transporte",
	"7501": "Exportação de mercadorias recebidas com fim específico de exportação",
	"7504": "Exportação de mercadoria que foi objeto de formação de lote de exportação",
	"7551": "Venda de bem do ativo imobilizado",
	"7552":
		"Saída de produto destinado para uso ou consumo de bordo, em embarcações ou aeronaves exclusivamente em tráfego internacional com destino ao exterior",
	"7553": "Devolução de compra de bem para o ativo imobilizado",
	"7556": "Devolução de compra de material para uso ou consumo",
	"7651": "Venda de combustíveis ou lubrificantes de produção do estabelecimento",
	"7654": "Venda de combustíveis ou lubrificantes adquiridos ou recebidos de terceiros",
	"7667": "Saída de combustíveis ou lubrificantes a consumidor ou usuário final",
	"7930":
		"Lançamento efetuado a título de devolução de bem cuja entrada tenha ocorrido sob amparo de regime especial aduaneiro de admissão temporária",
	"7949": "Outra saída de mercadoria ou prestação de serviço não especificada",
};

/**
 * Shape a CFOP code has to be written in: the 4 digits, optionally split after the series
 * digit by a single whitespace or mask character, the way the annex prints them ("1.101").
 */
export const CFOP_FORMAT_REGEX = /^\d[\s.\-/]?\d{3}$/;
